import { numberWithCommas } from "lib/format_helper";
import { getWinRateColor } from "lib/general-helper";
import { decimalToPercentage, getDeadlockTierColor, getDeadlockTierLetter } from "lib/tierHelper";

interface HeroStatsProps {
  data: {
    tierNumber: number;
    winRate: number;
    pickRate: number;
    kda: number;
    games: number;
    rank: number;
  };
}

const HeroStats = (props: HeroStatsProps) => {
  const { data } = props;
  const winRateAsPercentage = data.winRate.toFixed(1);

  return (
    <div className="hero-stats-container">
      <div className="hero-stat-box">
        <div className="hero-stat-value" style={{ color: getDeadlockTierColor(data.tierNumber) }}>
          {getDeadlockTierLetter(data.tierNumber)}
        </div>
        <div className="hero-stat-label">Tier</div>
      </div>
      <div className="hero-stat-box">
        <div className="hero-stat-value" style={{ color: getWinRateColor(winRateAsPercentage) }}>
          {winRateAsPercentage}%
        </div>
        <div className="hero-stat-label">Win Rate</div>
      </div>
      <div className="hero-stat-box">
        <div className="hero-stat-value">{data.rank}/22</div>
        <div className="hero-stat-label">Rank</div>
      </div>
      <div className="hero-stat-box">
        <div className="hero-stat-value">{data.pickRate.toFixed(1)}%</div>
        <div className="hero-stat-label">Pick Rate</div>
      </div>
      <div className="hero-stat-box">
        <div className="hero-stat-value">{data.kda.toFixed(1)}</div>
        <div className="hero-stat-label">KDA</div>
      </div>
      <div className="hero-stat-box last">
        <div className="hero-stat-value">{numberWithCommas(data.games)}</div>
        <div className="hero-stat-label">Matches</div>
      </div>
    </div>
  );
};

export default HeroStats;
